import { http } from './client'

/** DEC-200: the TDIA GitHub App and its Setup flow. */
export interface GitHubAppInfo {
  configured: boolean
  install_url: string | null
}

export interface GitHubSetupResult {
  workspace_name: string
  account_login: string | null
  repositories: string[]
  repository_selection: string | null
  signed_in: boolean
}

/** DEC-201: a workspace API key for the connector Action. `key` only on creation. */
export interface ApiKey {
  key_id: string
  name: string
  prefix: string
  created_at: string
  last_used_at: string | null
  revoked_at: string | null
  key?: string
}

export const githubAppApi = {
  info: (): Promise<GitHubAppInfo> => http.get('/api/v1/github/app'),
  setup: (code: string, installationId: string): Promise<GitHubSetupResult> =>
    http.post('/api/v1/github/setup', { code, installation_id: installationId }),
}

export const apiKeysApi = {
  list: (): Promise<{ keys: ApiKey[] }> => http.get('/api/v1/settings/api-keys'),
  create: (name: string): Promise<ApiKey> => http.post('/api/v1/settings/api-keys', { name }),
  revoke: (keyId: string): Promise<ApiKey> => http.delete(`/api/v1/settings/api-keys/${keyId}`),
}
